import React, { useState } from 'react'
import { Link } from 'gatsby';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation } from "@reach/router"
import Modal from "react-bootstrap/Modal"
import { ShareIcon } from './Components/icons';
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton
}
    from "react-share";
import {
    EmailIcon,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon
} from "react-share"

const SocialShare = (props) => {
	    const [Shareicons, setShareicons] = React.useState(false);
	    const location = useLocation();
    	const shareUrl = location.href
		const openShareicons = () => {
            setShareicons(!Shareicons)
	    }
	  const [show, setShow] = useState(false);

	  const handleClose = () => setShow(false);
      const handleShow = (event) => {   
        setShow(true);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Share - social icons',
          'formType': event + ' - ' +shareUrl,
          'formId': 'Share',
          'formName': 'Share',
          'formLabel': 'Share'
        });   
    }
      const trackerShare = (event) => {    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Share - social icons',
          'formType': event + ' - ' +shareUrl,
          'formId': 'Share',
          'formName': 'Share',
          'formLabel': 'Share'
        });    
    }

	    return (
        <>
		<a onClick={openShareicons}  href="javascript:void(0)" className={props.class?props.class:"btn-share share-link"}>
        {props.type==="property"?<ShareIcon/>:<i className="icon-share"></i>}
        {props.name?props.name:"Share"}
        {Shareicons &&
        <div className="hover-share">
            <FacebookShareButton onClick={()=>trackerShare('FacebookShareButton')} url={shareUrl} className="my-share-button facebook-share">
                <FacebookIcon size={32} round={false} borderRadius={`10`} />
            </FacebookShareButton>
            <TwitterShareButton onClick={()=>trackerShare('TwitterShareButton')} url={shareUrl} className="my-share-button twitter-share">
                <TwitterIcon size={32} round={false} borderRadius={`10`} />
            </TwitterShareButton>
            {props.type==="property" &&
            <Link to={`/send-to-friend?pid=${props.id}`} className="my-share-button email-share">
            <EmailIcon size={32} round={false} borderRadius={`10`} />
            </Link>
            }
            <LinkedinShareButton onClick={()=>trackerShare('LinkedinShareButton')} url={shareUrl} className="my-share-button linked-share">
                <LinkedinIcon size={32} round={false} borderRadius={`10`} />
            </LinkedinShareButton>

            <WhatsappShareButton onClick={()=>trackerShare('WhatsappShareButton')} url={shareUrl} className="my-share-button whatsapp-share">
                <WhatsappIcon size={32} round={false} borderRadius={`10`} />
            </WhatsappShareButton>
        </div>
    }
		</a>  
        </>
)

}
export default SocialShare
